import React, {useEffect, useState} from "react";
import {Container} from "react-bootstrap";
import ReactGA from "react-ga";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import ResellerAction from "../libs/ResellerAction";
import Subscription from "../../subscription/libs/Subscription";

function PaymentSuccess() {
    const [firstPaymentId, setFirstPaymentId] = useState("");
    const [paymentMessage, setPaymentMessage] = useState("");
    const [paymentSubMessage, setPaymentSubMessage] = useState("");
    const companyId = localStorage.getItem("companyId");
    const userId = localStorage.getItem("userId");
    const {t} = useTranslation();

    useEffect(() => {
        if (companyId) {
            Subscription.getPayment(companyId)
                .then((res) => {
                    setFirstPaymentId(res.payment_id);
                })
                .catch((error) => console.log(error));
        }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (firstPaymentId && companyId)
            Subscription.checkPaymentStatus(companyId, firstPaymentId)
                .then((res) => {
                    if (res?.paymentSuccessful === true) {
                        ResellerAction.resellerSubscription(res.payment.id, userId).catch(() => {
                        });
                        setPaymentMessage(res.message);
                        setPaymentSubMessage(res.subMessage);
                        if (res.payment && res.payment.amount && res.payment.amount.value) {
                            let amount = res.payment.amount.value;
                            ReactGA.event({
                                action: "Purchase",
                                category: "Purchase",
                                label: "Guest Purchase",
                                value: amount,
                            });

                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: "event",
                                eventProps: {
                                    action: "Purchase",
                                    category: "Purchase",
                                    label: "Guest Purchase",
                                    value: amount,
                                },
                            });
                        }
                    } else if (res.paymentSuccessful === false) {
                        setPaymentMessage(res.message);
                    }
                })
                .catch((error) => console.log(error));
        //eslint-disable-next-line
    }, [firstPaymentId]);


    return (
        <Container className="full-height-container ">
            <>
                <div className="col-md-12 card o-hidden border-0 shadow-lg my-5">
                    <div className="card-body p-0">
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="py-5">
                                    <div className="d-flex justify-content-center text-center">
                                        <h1>{paymentMessage ? paymentMessage : <>{t('Loading')}...</>} </h1>
                                    </div>
                                    <div className="d-flex justify-content-center text-center">
                                        {paymentSubMessage && <p>{paymentSubMessage}</p>}
                                    </div>
                                    {paymentMessage &&
                                        <div className="d-flex justify-content-center">
                                        <Link to="/reseller/user">
                                            <button className="btn btn-primary">
                                                {t("Go to user dashboard")}
                                            </button>
                                        </Link>
                                        </div> }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </Container>
    );
}

export default PaymentSuccess;
